import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { FormArray, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { FilterValuesSelectComponent } from 'src/app/components/filter-values-select/filter-values-select.component';
import { SelectComponent } from 'src/app/components/select/select.component';
import { Filter } from '../../../../models/filter';
import { AppPlatform } from '../../../../models/platform';
import { RegexUtils } from '../../../../utils/regex.utils';

@Component({
    selector: 'app-filter-variant',
    templateUrl: './filter-variant.component.html',
    styleUrls: ['./filter-variant.component.scss'],
    imports: [CommonModule, ReactiveFormsModule, FormsModule, SelectComponent, FilterValuesSelectComponent],
})
export class FilterVariantComponent implements OnInit {
    filterValues: { value: string; label: string }[] = [];
    isFilterValue: boolean;
    _filter: Filter;
    @Input() withOffers?: boolean;
    @Input() platform?: AppPlatform;
    inputType: 'text' | 'number' | 'date';
    inputValidators: any[] = [Validators.required];

    @Input() set filter(filter: Filter) {
        if (!filter || this._filter) {
            return;
        }
        this.isFilterValue = filter.type === 'single_choice' || filter.type === 'multi_choice';
        this.filterValues = filter.filterValues.map((v) => ({
            value: v.code,
            label: v.value,
        }));
        this._filter = filter;
        if (!this.isFilterValue) {
            switch (this._filter.type) {
                case 'decimal':
                    this.inputType = 'number';
                    this.inputValidators.push(Validators.pattern(RegexUtils.decimal));
                    break;
                case 'integer':
                    this.inputValidators.push(Validators.pattern(RegexUtils.integer));
                    this.inputType = 'number';
                    break;
                case 'year':
                    this.inputValidators.push(...[Validators.max(2050), Validators.min(1800)]);
                    this.inputType = 'number';
                    break;
                case 'text':
                    this.inputType = 'text';
                    break;
                case 'date':
                    this.inputType = 'date';
                    break;
            }
        }
    }

    @Input() form: FormGroup;

    constructor() {}

    ngOnInit() {}

    addValue() {
        const control = this.form.get(this._filter.getCode()) as FormArray;
        control.push(
            new FormGroup({
                value: new FormControl('', this.inputValidators),
            }),
        );
    }

    removeValue(index: number) {
        const control = this.form.get(this._filter.getCode()) as FormArray;
        control.removeAt(index);
    }

    getValues(): FormGroup[] {
        if (!this.form.contains(this._filter.getCode())) {
            return [];
        }
        const control = this.form.get(this._filter.getCode()) as FormArray;
        return (control?.controls as FormGroup[]) || [];
    }
}
